<template>
  <div>
    <router-view></router-view>
    <PageHeaderLayout>
      <el-button @click="event_pageBack">返回</el-button>
      <div class="main-page-content">
        <el-row style="height: 36px">
          <el-form :inline="true" :model="searchCondition" class="searchArea">
			<div>
				<el-form-item label="姓名">
				<el-input
				v-model="searchCondition.bank_account_name"
				placeholder="输入姓名"
				class="item-name"
				clearable
				@input="event_searchChange"
				></el-input>
				</el-form-item>
<!-- 				<el-form-item label="时间">
				<el-date-picker
				v-model="searchCondition.month"
				type="month"
				placeholder="选择一个月份"
				value-format="yyyy-MM"
				@change="event_searchChange"
				/>
				</el-form-item> -->
			</div>

			<el-button class="btn_export" type="primary" @click="event_export">导出</el-button>
          </el-form>
        </el-row>
        <ApeTable
          ref="apeTable"
          :data="companyList"
          :columns="columns"
          :loading="loadingStaus"
          :pagingData="pagingData"
          @switchPaging="switchPaging"
          highlight-current-row
        >
            <template #first-column>
              <span>
                <el-button size="mini" @click="viewButton(scope.row)">查看</el-button>
              </span>
            </template>
			
			<el-table-column
			width="180"
			header_align="center"
			align="center"
			label="操作"
			>
			<template slot-scope="scope">
			<span>
			<el-button size="mini" @click="event_updateXiafa(scope.row)">修改下发金额</el-button>
			</span>
			</template>
			</el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>
	<!-- 添加列弹窗 -->
	<ModalDialog :dialogData="addColumnDialogData" @dialogConfirm="addColumnConfirm" @dialogClose="addColumnDialogClose">
		<template slot="content">
			<p>字段名称</p>
			<el-input style="width: 240px;" v-model="addColumnDialogForm.columnName" placeholder="字段名称"></el-input>
			<p>关联字段</p>
			<el-select
			v-model="addColumnDialogForm.selectColumn"
			class="m-2"
			placeholder="请选择"
			size="large"
			style="width: 240px"
			>
				<el-option
				v-for="item in columns"
				:key="item.value"
				:label="item.title"
				:value="item.value"
				/>
			</el-select>
		</template>
	</ModalDialog>
	<!-- 审核模态框 -->
	<ModalDialog :dialogData="exportDialogData" @dialogConfirm="exportConfirm" @dialogClose="exportDialogClose">
		<template slot="content">
			<el-form :model="examineRuleForm" ref="examineRuleForm" class="demo-ruleForm">
			<el-form-item label="表名">
			<el-input v-model="exportForm.name" placeholder="请输入表名"></el-input>
			</el-form-item>
			<el-form-item label="字段">
				<el-button @click="event_addColumn">添加列</el-button>
				<el-table :data="[companyList[0]]||companyList" style="width: 100%">
					<el-table-column :key="index" v-for="(item,index) in exportForm.columns" :prop="item.prop" :label="item.label" />
				</el-table>
			</el-form-item>
			</el-form>
		</template>
	</ModalDialog>
    <!-- 审核模态框 -->
     <ModalDialog :dialogData="examineDialogData" @dialogConfirm="examineHandleConfirm" @dialogClose="examineDialogClose">
      <template slot="content">
        <el-form :model="examineRuleForm" ref="examineRuleForm" class="demo-ruleForm" :label-position="'right'" >
          <el-form-item>
            <el-radio-group v-model="examineRuleForm.status">
              <el-radio label="1">通过</el-radio>
              <el-radio label="2">拒绝</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="examineRuleForm.status == 2">
            <el-input type="textarea" :rows="4" v-model="examineRuleForm.remark" placeholder="请输入拒绝原因"></el-input>
          </el-form-item>
        </el-form>
      </template>
    </ModalDialog>
    <!-- 办理模态框 -->
    <ModalDialog :dialogData="handleDialogData" @dialogConfirm="handleConfirm" @dialogClose="handleDialogClose">
      <template slot="content">
        <el-form :model="handleRuleForm" ref="handleRuleForm" class="demo-ruleForm" :label-position="'right'" >
          <el-form-item>
            <el-radio-group v-model="handleRuleForm.status">
              <el-radio label="2">办理成功</el-radio>
              <el-radio label="3">办理失败</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="handleRuleForm.status == 5">
            <el-input type="textarea" :rows="4" v-model="handleRuleForm.remark" placeholder="请输入办理失败原因"></el-input>
          </el-form-item>
        </el-form>
      </template>
    </ModalDialog>
	<!-- 修改下发金额 -->
	<ModalDialog :dialogData="XiafahandleDialogData" @dialogConfirm="XiafahandleDialog_handleConfirm" @dialogClose="XiafahandleDialog_handleDialogClose">
	<template slot="content">
	<el-form>
		<el-form-item>
		<el-radio-group v-model="XiafaForm.changeType">
			<el-radio :label="1">增加</el-radio>
			<el-radio :label="2">减少</el-radio>
		</el-radio-group>
		</el-form-item>
		<el-form-item label="金额">
			<el-input type="number" v-model="XiafaForm.edit_money" placeholder="请输入金额"></el-input>
		</el-form-item>
	</el-form>
	</template>
	</ModalDialog>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeTable from "@/components/ApeTable";
import DatePicker from "@/components/DatePicker.vue";
import ModalDialog from '@/components/ModalDialog'
import { mapGetters, mapState } from "vuex";

export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    DatePicker,
    ModalDialog
  },
  data() {
    return {
		XiafaForm:{
			changeType:1,
			edit_money:''
		},
		XiafahandleDialogData:{
		visible: false,
		title: '修改下发金额',
		width: '40%',
		},
      addColumnDialogForm:{
        selectColumn:'',
		columnName:''
      },
      addColumnDialogData:{
		visible: false,
		title: '选择列',
		width: '40%',
      },
      exportDialogData:{//导出模态框
		visible: false,
		title: '导出',
		width: '40%',
      },
      exportForm:{
		name:'',
		columns:[
			{
				label:'姓名',
				prop:'bank_account_name'
			},
			{
				label:'证件类型',
				prop:'card_type'
			}
		]
      },
      examineDialogData: {//审核模态框
        visible: false,
        title: '',
        width: '40%',
        loading: true,
        modal: false
      },
      examineRuleForm: {//审核表单数据
        id: '',
        status: '',
        remark: ''
      },
      handleDialogData: {
        visible: false,
        title: '',
        width: '40%',
        loading: true,
        modal: false
      },
      handleRuleForm: {
        id: '',
        status: '',
        remark: ''
      },
      searchCondition: {},
      companyList: [],
      columns: [
		{
			title: '姓名',
			value: 'bank_account_name',
			header_align: 'center',
			align: 'center',
		},
		{
			title: '证件类型',
			value: 'card_type',
			header_align: 'center',
			align: 'center',
		},
		{
			title: '身份证',
			value: 'id_number',
			header_align: 'center',
			align: 'center',
		},
		{
			title: '国籍',
			value: 'country',
			header_align: 'center',
			align: 'center',
		},
        {
          title: '税源地地址',
          value: 'channel_name',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '登记注册类型',
          header_align: 'center',
          align: 'center',
          value: 'regType',
        },
        {
          title: '手机号码',
          value: 'mobile',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '税种',
          value: 'taxType',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '税率',
          value: 'taxFee',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '行业',
          value: 'industry',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '经营范围',
          value: 'business_scope',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '下发金额',
          value: 'money',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '个税核定（定期定额）',
          value: 'taxHD',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '当期成本',
          value: 'const_money',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '报税金额',
          value: 'tax_money',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '公司',
          value: 'company_name',
          header_align: 'center',
          align: 'center',
        }
      ],
      options: [{
        value: '1',
        label: '办理中'
      },{
        value: '2',
        label: '办理成功'
      }, 
      {
        value: '3',
        label: '办理失败'
      }],
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
		offset:0
      },
      // 分页的offset,序号列使用
      offset:0,
      loadingStaus: true,
    };
  },

  computed: {
    ...mapGetters(["userPermissions", "buttonType"]),
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },
  watch: {
    "$route.matched": function (n, o) {
      console.log(o);
      if (n.length === 2) {
        this.init();
      }
    },
    "examineRuleForm.status": function(val) {
      if(val) {
        this.examineDialogData.loading = false
      }else {
        this.examineDialogData.loading = true
      }
    },
    "handleRuleForm.status": function(val) {
      if(val) {
        this.handleDialogData.loading = false
      }else {
        this.handleDialogData.loading = true
      }
    }
  },
  methods: {
	async XiafahandleDialog_handleConfirm(){
		let {id,channel_account,id_number,company_id,yl_bank,
			money,person_channel_money,month,edit_money} = this.XiafaForm
		let obj = {
			id,channel_account,id_number,company_id,yl_bank,
			money,person_channel_money,month,edit_money
		}
		if(this.XiafaForm.changeType == 2){
			if(parseInt(this.edit_money) == money){
				this.$message.warning('减少的金额不可和下发金额一致')
				return false
			}else{
				obj.edit_money = obj.edit_money * -1
			}
		}
		obj.edit_money = Number(obj.edit_money)
		await this.$api.getpersonalTaxEdit(obj);
		this.XiafahandleDialogData.visible = false
		this.init();
	},
	XiafahandleDialog_handleDialogClose(){
		this.XiafahandleDialogData.visible = false
	},
	event_updateXiafa(e){
	this.XiafaForm.id = e.id
	this.XiafaForm.channel_account = e.channel_account
	this.XiafaForm.id_number = e.id_number
	this.XiafaForm.company_id = e.company_id
	this.XiafaForm.yl_bank = e.yl_bank
	this.XiafaForm.money = e.money
	this.XiafaForm.person_channel_money = e.person_channel_money
	this.XiafaForm.month = this.$router.currentRoute.query.month
	
	this.XiafahandleDialogData.visible = true
	},
	//转换导出数据
	formatJson(jsonData) {
		return jsonData.map(v => {
			let arr = []
			this.exportForm.columns.map(item=>{
				arr.push(v[item.prop])
			})
			return arr
		})
	},
    async exportConfirm(){
		let searchCondition = this.handleSearchCondition();
		let pagingInfo = {
			current_page: 1,
			page_size: 10000
		}
		let {channel_account,company_id} = this.$router.currentRoute.query
		let routeArg = {
			channel_account,company_id
		}
		Object.assign(searchCondition, pagingInfo, routeArg);
		let { data } = await this.$api.getMxWithdrawListTax(searchCondition);
		data.map(item=>{
		item.card_type = '身份证'
		item.country = '中国'
		item.regType = '内资个人'
		item.taxType = '增值税、附加税、个人经营所得税'
		item.taxFee = '0%'
		item.industry = '服务'
		item.business_scope = '现代服务'
		item.taxHD = '月10万免征'
		// item.cost = item.money - (item.money * 0.0025)
		// item.taxPrice = item.money * 0.0025
		item.company_name = item.company.name
		})
		let tHeader = []
		this.exportForm.columns.map(item=>{
			tHeader.push(item.label)
		})
		let exportData = this.formatJson(data)
		
		import('@/excel/Export2Excel').then(excel => {
		const time = new Date().getTime() + Math.random() * 1000
		let filename = `${this.exportForm.name}${time}`
		excel.export_json_to_excel({
		header: tHeader, //Header Required
		data:exportData, //Specific data Required
		filename: filename, //Optional
		autoWidth: true, //Optional
		bookType: 'xlsx', //Optional
		})
		})
		this.exportDialogClose()
	},
    //确认弹窗
    addColumnConfirm(){
		let obj = {
			label:this.addColumnDialogForm.columnName,
			prop:this.addColumnDialogForm.selectColumn
		}
		this.exportForm.columns.push(obj)
		this.addColumnDialogData.visible = false
	},
    addColumnDialogClose(){
      this.addColumnDialogData.visible = false
	},
	//增加列弹窗打开
    event_addColumn(){
      this.addColumnDialogData.visible = true
      this.addColumnDialogForm.columnName = ''
      this.addColumnDialogForm.selectColumn = ''
	},
    event_pageBack(){
      this.$router.back()
	},
	exportDialogClose(){
		this.exportDialogData.visible = false
	},
	event_export(){
		this.exportDialogData.visible = true
		this.exportForm.columns = [
				{
					label:'姓名',
					prop:'bank_account_name'
				},
				{
					label:'证件类型',
					prop:'card_type'
				}
		]
	},
    event_searchChange(){
		this.init('search')
	},
    //删除 
    async deleteButton(id) {
      let args = {
        id
      }
      let result = await this.$api.individualDelete(args)
      if(result) {
        this.init()
        this.$message.success('删除成功')
      }
    },
    // 响应详情按钮
    async viewButton(id) {
      console.log(id)
      this.$router.push('/personalTax/detail')
    },
    //个体户审核
    async individualAudit() {
      let result = await this.$api.individualAudit(this.examineRuleForm)
      if(result) {
        this.examineDialogData.visible = false
        this.examineRuleForm = {}
        this.init()
        this.$message.success('审核完成')
      } 
    },
    //个体户办理
    async individualHandle() {
      let result = await this.$api.individualAudit(this.handleRuleForm)
      if(result) {
        this.handleDialogData.visible = false
        this.handleRuleForm = {}
        this.init()
        this.$message.success('办理完成')
      }
    },
    //审核确定模态框
    examineHandleConfirm() {
      this.$refs['examineRuleForm'].validate((valid) => {
        if(valid) {
          this.individualAudit()
        }
      })
    },
    //审核关闭模态框
    examineDialogClose() {
      this.examineDialogData.visible = false
      this.examineRuleForm = {}
    },
    //办理确定模态框
    handleConfirm() {
      this.$refs['handleRuleForm'].validate((valid) => {
        if(valid) {
          this.individualHandle()
        }
      })
    },
    //办理关闭模态框
    handleDialogClose() {
      this.handleDialogData.visible = false
      this.handleRuleForm = {}
    },
    //查询按钮
    searchButton() {
      this.init('search')
    },  
    //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.start_time = value[0];
      this.searchCondition.end_time = value[1];
    },
    // 初始化列表
    async init(type) {
      if (type) {
        this.mxResetPage();
      }
      let pagingInfo = this.$refs["apeTable"].getPagingInfo(type);
      if (type == "search") {
        pagingInfo.current_page = 1;
      }
      let searchCondition = this.handleSearchCondition();
      console.log(this.$router.currentRoute,'路由信息')
      let {channel_account,company_id} = this.$router.currentRoute.query
      let routeArg = {
        channel_account,company_id
      }
      Object.assign(searchCondition, pagingInfo, routeArg);
      let { data, pages } = await this.$api.getMxWithdrawListTax(searchCondition);
      console.log(data,'返回数据')
      data.map(item=>{
        item.card_type = '身份证'
		item.country = '中国'
		item.regType = '内资个人'
		item.taxType = '增值税、附加税、个人经营所得税'
		item.taxFee = '0%'
		item.industry = '服务'
		item.business_scope = '现代服务'
		item.taxHD = '月10万免征'
		// item.cost = item.const_money
		// item.taxPrice = item.tax_money
		item.company_name = item.company.name
      })
      this.companyList = data;
      this.pagingData.total = pages.total;
      this.offset = pages.offset;
      this.pagingData.offset = (pages.current_page - 1) * pages.page_size;
      this.loadingStaus = false;
    },
	//获取一个月有多少天
	getDaysInMonth(year,month){
		return new Date(year, month, 0).getDate();
	},
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {};
      if (this.searchCondition.bank_account_name) {
        condition.bank_account_name = this.searchCondition.bank_account_name;
      }
      let tarVal = this.$router.currentRoute.query.month
      if (tarVal) {
        let tar = tarVal.split("-");
		let date = this.getDaysInMonth(tar[0],tar[1])
        // condition.month = this.searchCondition.month;
		condition.start_time = `${tar[0]}-${tar[1]}-01 00:00:00`
		condition.end_time = `${tar[0]}-${tar[1]}-${date} 23:59:59`
		
      }
		condition.yl_bank = this.$router.currentRoute.query.yl_bank
		console.log(condition,'查询条件')
      return condition;
    },
    //分页
    switchPaging() {
    this.init();
    },
    //审核操作
    examineButton(id) {
      this.examineDialogData.visible = true
      this.examineRuleForm.id = id
    },
    //办理操作
    handleButton (id) {
      this.handleDialogData.visible = true
      this.handleRuleForm.id = id
    }
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="stylus" scoped>
.searchArea{
	display: flex;justify-content: space-between;
}
.btn_export{
	height: 34px;
}
/deep/.el-checkbox-group label {
  width: 180px;
}

/deep/.el-checkbox-group label:first-child {
  margin-left: 10px;
}

/deep/.el-checkbox-group {
  // width: 660px
}

.el-button {
  margin-right: 4px;
  margin-bottom: 4px;
}

.item-name {
  width: 130px;
}

.table-header-gai {
  height: 35px;
}

.table-header {
  margin-bottom: 12px;
}

.el-popover .el-checkbox-group .el-checkbox {
  margin-left: 0px;
  margin-right: 12px;
}

.returnBtn {
  position: relative;
  top: 10px;
  float: right;
}

.table-right {
  float: right;
}

.submitBtn {
  float: right;
  margin-top: 20px;
}

.link-url {
  color: #fff;
  text-decoration: none;
}

.cusomer-link-gai {
  position: absolute;
  top: 0;
  font-size: 15px;
  width: 160px;
}

.cusomer-link {
  position: absolute;
  top: 0;
  right: 0;
}

.total-num {
  float: right;
  margin-top: 10px;
  margin-right: 20px;
  // position: absolute;
  // top: 0
  // right: 0
  // line-height: 40px
  // padding-right: 20px
}

.span-num {
  color: #f00;
}

.selectWord {
  width: 150px;
}

.link-title {
  text-align: center;
  padding-bottom: 10px;
  color: red;
}

.people-btn-wrapper {
  margin-top: 20px;
}

.dialog-title {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  margin-top: -20px;
}

.title-text {
  font-size: 20px;
  margin-left: 10px;
}

.center-box {
  display: flex;
  justify-content: center;
  align-item: center;
  padding: 30px 0;
}

.QR-code {
  width: 150px;
  height: 150px;
}

.main-page-content {
  position: relative;
}

.select-box {
  width: 100px;
}
</style>
